import { Box, Text } from '@chakra-ui/react';
import IconComponent from '../../../../IconComponent/IconComponent';

interface HelperBoxProps {
  onHide: () => void;
}

export const HelperBox = ({ onHide }: HelperBoxProps) => {
  return (
    <section className="relative p-4 gap-4 flex justify-between items-start border border-brand-300 bg-brand-50 shadow-lg shadow-gray-100">
      <div className="p-spacing-md border border-gray-200">
        <IconComponent iconName="question" />
      </div>
      <Box className="flex-1">
        <Text className="font-semibold text-sm text-grayLight-900">Jak to działa?</Text>
        <Text className="font-normal text-sm text-grayLight-700">
          Przycisk "Odrzuć" odrzuca zgłoszenia. Przycisk "Akceptuj" tworzy konto ucznia przypisane
          do zgłaszającego rodzica i zamyka kandydaturę. Zaznaczając kilka zgłoszeń można
          zaakceptować lub odrzucić zgłoszenia zbiorowo.
        </Text>
        <Text className="font-normal text-sm text-grayLight-700 mt-1">
          Jeśli uczeń istnieje w systemie pojawi się komunikat oraz możliwość połączenia konta
          Rodzica z istniejącym kontem ucznia.
        </Text>
      </Box>
      <button
        type="button"
        onClick={onHide}
        className="absolute top-4 right-4 text-gray-400 hover:text-gray-600">
        <IconComponent iconName="xClose" className="w-3 h-3" />
      </button>
    </section>
  );
};
